const basicInsuranceCategory = {
  id: '',
  name: '',
  code: '',
  category: 0,
  active: true
};

export default basicInsuranceCategory;
